/**
 * dfe-diamond-share.js — DFE NZ
 * Share copies ?diamondId=<SKU>. Opening that URL looks up the cert via
 * the existing report-number search, then clicks the matching card.
 */
(function () {
  'use strict';

  var DFE_PARAM = 'diamondId';

  function pendingSku() {
    if (window.__dfePendingDiamondId) return String(window.__dfePendingDiamondId);
    try { return new URL(window.location.href).searchParams.get(DFE_PARAM) || ''; }
    catch (e) { return ''; }
  }

  function setUrlParam(sku) {
    try {
      var url = new URL(window.location.href);
      if (sku) url.searchParams.set(DFE_PARAM, sku);
      else url.searchParams.delete(DFE_PARAM);
      history.replaceState(history.state || {}, '', url.pathname + url.search);
    } catch (e) {}
  }

  function finishDeeplink() {
    window.__dfePendingDiamondId = '';
    document.documentElement.classList.remove('dfe-deeplink-pending');
  }

  function returnToFullSearch() {
    var returnUrl = window.__dfeReturnSearchUrl;
    finishDeeplink();
    window.__dfeOpenedFromShare = false;
    window.__dfeReturnSearchUrl = '';
    if (returnUrl) {
      window.location.assign(returnUrl);
      return;
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('diamondId');
      url.searchParams.delete('CertNumber');
      url.searchParams.delete('cert_number');
      window.location.assign(url.pathname + (url.search || ''));
    } catch (e) {
      window.location.assign(window.location.pathname);
    }
  }

  function showSoldModal() {
    finishDeeplink();
    var modal = document.getElementById('DfeDiamondSoldModal');
    if (!modal) return;
    modal.hidden = false;
    function close() { modal.hidden = true; setUrlParam(''); }
    modal.querySelectorAll('[data-dfe-sold-close]').forEach(function (el) {
      el.addEventListener('click', close, { once: true });
    });
  }

  function getSkuFromPage() {
    var skuEl = document.querySelector('[data-detail-sku]');
    var sku = (skuEl ? String(skuEl.textContent || '') : '').replace(/^SKU:\s*/i, '').trim();
    if (!sku || sku === '—' || sku === '-') return '';
    return sku;
  }

  function shareUrlForSku(sku) {
    var url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set(DFE_PARAM, sku);
    try {
      var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
    } catch (e) {}
    return url.toString();
  }

  function detailUrlForSku(sku) {
    var url = new URL(window.location.href);
    url.searchParams.delete('CertNumber');
    url.searchParams.delete('cert_number');
    url.searchParams.set(DFE_PARAM, sku);
    return url.toString();
  }

  function flashCopied(btn) {
    var lbl = btn.querySelector('[data-dfe-share-label]');
    btn.classList.add('dfe-share-btn--copied');
    if (lbl) lbl.textContent = 'Link Copied!';
    setTimeout(function () {
      btn.classList.remove('dfe-share-btn--copied');
      if (lbl) lbl.textContent = 'Share';
    }, 2500);
  }

  function fallbackCopy(url, btn) {
    var ta = document.createElement('textarea');
    ta.value = url; ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    flashCopied(btn);
  }

  function copyShareUrl(url, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { flashCopied(btn); }).catch(function () { fallbackCopy(url, btn); });
    } else {
      fallbackCopy(url, btn);
    }
  }

  if (!window.__dfeShareClickBound) {
    window.__dfeShareClickBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-dfe-share-btn]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var sku = getSkuFromPage();
      if (!sku) return;
      copyShareUrl(shareUrlForSku(sku), btn);
    }, true);
  }

  // Open browse-result diamonds in a new tab while keeping all active filter
  // parameters in that tab's URL. The originating list remains untouched.
  if (!window.__dfeDiamondNewTabBound) {
    window.__dfeDiamondNewTabBound = true;

    function openCardInNewTab(e) {
      if (!e.target || !e.target.closest) return;
      var card = e.target.closest('li[data-diamond-card], tr[data-diamond-card]');
      if (!card) return;

      // Do not intercept the programmatic card open used by a shared URL.
      if (pendingSku() || window.__dfeOpenedFromShare) return;

      var item = parseCardItem(card);
      var sku = item && String(item.certNumber || item.diamondId || item.offerId || '').trim();
      if (!sku) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.open(detailUrlForSku(sku), '_blank', 'noopener');
    }

    document.addEventListener('click', openCardInNewTab, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      openCardInNewTab(e);
    }, true);
  }

  document.addEventListener('click', function (e) {
    if (
      window.__dfeOpenedFromShare &&
      e.target.closest &&
      e.target.closest('[data-back-to-search]')
    ) {
      returnToFullSearch();
    }
  }, true);

  function itemMatches(item, sku) {
    if (!item || !sku) return false;
    var a = String(sku).trim().toUpperCase();
    var ids = [item.certNumber, item.diamondId, item.offerId, item.sku];
    for (var i = 0; i < ids.length; i++) {
      if (String(ids[i] || '').trim().toUpperCase() === a) return true;
    }
    return false;
  }

  function parseCardItem(card) {
    var el = card.querySelector('[data-diamond-payload]') || card;
    var raw = el.getAttribute('data-diamond-payload');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function findCardToOpen(sku) {
    var cards = document.querySelectorAll('li[data-diamond-card]');
    if (!cards.length) return null;
    for (var i = 0; i < cards.length; i++) {
      var item = parseCardItem(cards[i]);
      if (itemMatches(item, sku)) return { card: cards[i], item: item };
    }
    if (window.__dfeCertSearchStarted && cards.length === 1) {
      return { card: cards[0], item: parseCardItem(cards[0]) };
    }
    return null;
  }

  function openDiamondFromCard(found, sku) {
    if (!found) return false;
    finishDeeplink();
    setUrlParam(sku);
    var rbd = window.RingBuilderDiamonds;
    if (found.item && rbd && typeof rbd.openDiamondPreview === 'function') {
      rbd.openDiamondPreview(found.item);
    } else {
      found.card.click();
    }
    var lm = document.querySelector('[data-diamond-load-more]');
    if (lm) lm.style.display = 'none';
    return true;
  }

  function startCertSearch(sku) {
    var input = document.querySelector('#diamond-filter-cert-number');
    var btn = document.querySelector('#diamond-btn-search-cert');
    if (!input || !btn) return false;
    window.__dfeCertSearchStarted = true;
    input.value = sku;
    btn.click();
    return true;
  }

  function pollForDiamond(sku) {
    if (window.__dfeOpenPoll) return;
    var ticks = 0;
    window.__dfeOpenPoll = setInterval(function () {
      ticks++;
      var skuNow = pendingSku() || sku;
      if (!skuNow) {
        clearInterval(window.__dfeOpenPoll);
        window.__dfeOpenPoll = null;
        return;
      }
      if (openDiamondFromCard(findCardToOpen(skuNow), skuNow)) {
        clearInterval(window.__dfeOpenPoll);
        window.__dfeOpenPoll = null;
        return;
      }
      if (ticks === 8 && !window.__dfeCertSearchStarted) startCertSearch(skuNow);
      if (ticks > 50) {
        clearInterval(window.__dfeOpenPoll);
        window.__dfeOpenPoll = null;
        showSoldModal();
      }
    }, 200);
  }

  var bootSku = pendingSku();
  if (bootSku) pollForDiamond(bootSku);
}());
